"use strict";

var Heremaps = function() {
  var setOnMap = function(interpoints) {
    var platform = new H.service.Platform({ 
      apikey: "4AlEPV-K1xJJozp9jtTAS2ZSOKsBiuy_30YvObi0B2Y"
    }); 

    // Retrieve the target element for the map:
    var targetElement = document.getElementById('mapContainer');

    // Get the default map types from the platform object:
    var defaultLayers = platform.createDefaultLayers();

    // Instantiate the map:
    var map = new H.Map(
      document.getElementById('mapContainer'),
      defaultLayers.vector.normal.map,
      {
        zoom: 0,
        center: { lat: 52.51, lng: 13.4 }
      });

    var ui = H.ui.UI.createDefault(map, defaultLayers, 'en-US'); 
    var mapEvents = new H.mapevents.MapEvents(map); 
    var behavior = new H.mapevents.Behavior(mapEvents); 

    var waypoints = [];

    if (interpoints != null && interpoints != undefined && interpoints.length > 1) {
      waypoints = interpoints.split(';');
    }

    var start = waypoints[0];
    var end = waypoints[waypoints.length-1];

    // Create the parameters for the routing request:
    var routingParameters = {
      'routingMode': 'fast',
      'transportMode': 'truck',
      'origin': start,
      'via': new H.service.Url.MultiValueQueryParameter(waypoints),
      'destination': end,
      'return': 'polyline'
    };

    // Define a callback function to process the routing response:
    var onResult = function(result) {
      // ensure that at least one route was found
      if (result.routes.length) {
        result.routes[0].sections.forEach((section) => {
            let linestring = H.geo.LineString.fromFlexiblePolyline(section.polyline);
            let routeLine = new H.map.Polyline(linestring, {
              style: { strokeColor: 'blue', lineWidth: 4 }
            });

            let startMarker = new H.map.Marker(section.departure.place.location);
            let endMarker = new H.map.Marker(section.arrival.place.location);

            map.addObjects([routeLine, startMarker, endMarker]);
            var bbox = new H.geo.Rect(40.97766,29.14188,40.25667,40.22342);
            map.getViewModel().setLookAtData({bounds: bbox});
        });
      }
    };

    // Get an instance of the routing service version 8:
    var router = platform.getRoutingService(null, 8);

    // Call calculateRoute() with the routing parameters,
    // the callback and an error callback function (called if a
    // communication error occurs):
    router.calculateRoute(routingParameters, onResult,
      function(error) {}
    );
  }

  return {
		init: function(waypoints) {
    setOnMap(waypoints);
		},

    initAjax: function(geocodes) {
      Heremaps.setOnMap(geocodes);
		},

    setOnMap: function(geocodes) {
      setOnMap(geocodes);
		}

	};

}();

// Webpack support
if (typeof module !== 'undefined') {
	module.exports = Heremaps;
}